import { CustomToastrAction, REDIRECT, toastr, TRANSLATION } from "@/imports-files/common/common";
import { CandidateEmail } from "@/services/components/candidate-email";
import {clearRadioButtonSelection, Kanban } from '@/imports-files/pages/clients/candidates/kanban';
import { ReviewEmailServices, ReviewEmailActions } from '@/imports-files/components/review-email';


export async function submitCandidateEmail(values, router, setEmailModal, setFlagForRerender, initialData, setInitialData, selectedValues, selectedToValues,setShowLoader, entity_id, entity_type, formRef)
{   
    //If user does not add any email besides default email in to then it should show the error to enter email
    if( formRef && values.email.forward && selectedToValues.length == 1) 
    {
         formRef.current.setStatus({'email':{'to':'Required'}});
         formRef.current.setFieldTouched('email.to', true)
         return null;
    }   
    
    setShowLoader(true);
    var cc_emails                =   getEmails(selectedValues);
    var to_emails                =   getEmails(selectedToValues);
    const formData               =   new FormData();
    const customToastrAction     =   new CustomToastrAction();
    // {console.log('setShowLoader')}
    // {console.log(values)}
    formData.append(`email[subject]`, values.email.subject);
    formData.append(`email[body]`, values.email.body);
    formData.append(`email[entity_type]`, values.email.entity_type);
    // formData.append(`email[reply_to]`, values.email.reply_to);
    values.email.reply_to ? formData.append(`email[reply_to]`, values.email.reply_to) : '';
    formData.append(`email[references]`, values.email.references);
    formData.append('email[cc]', cc_emails);
    formData.append('email[to]', to_emails);
    formData.append(`email[comm_detail_id]`, values.email.comm_detail_id);
    values.email.forward ? formData.append(`email[forward]`,values.email.forward) : '';

    values.email.attachments =  Array.from(values.email.attachments)

    values.email.attachments.map((file, index) => 
    {
        formData.append(`email[attachments][]`, file);
    })


    var result  = '';

    if(router.asPath.includes('/clients/candidates/') || entity_type == 'ClientCandidate')
    {
        result   = await new CandidateEmail().SendCandidateGeneralEmail(formData, router, entity_id);
    }
    else
    {
        result   = await new CandidateEmail().SendCandidateJobEmail(formData, router, entity_id);
    }
    

    if(result?.response?.status == 200 || result.status == 200)
    {   
        initialData.comms = result.data.comms;
        setInitialData(initialData);
        setFlagForRerender(Math.random() * 10000);
        setShowLoader(false);
        setEmailModal(false);
        customToastrAction.setNormalToastr(TRANSLATION('toastr:email_sent'), 'success'); 
        // toastr.success('The email has been sent successfully ');

        // If email is forward then move it to the inbox page
        if(values.email.forward) 
        {
            let link = REDIRECT.client.communication.index
            let params = router.query
            delete params['comm_detail_id']
            router.push({pathname: link, query: params})
        }

         // Call the show api again to shoe data
        // if(router.asPath.) 
        // {
        //     let link = REDIRECT.client.communication.index
        //     let params = router.query.params
        //     router.push({pathname: link, query: params})
        // }
    }
    else
    {
        setShowLoader(false);
        // setEmailModal(false);
        customToastrAction.setNormalToastr(result.response.data.error, 'warning'); 
        // toastr.warning(result.response.data.error);
    }

}


export async function submitKanbanEmail(args)
{   
    args.setShowLoader(true);
    var cc_emails                =   getEmails(args.selectedValues);
    const formData               =   new FormData();
    const customToastrAction     =   new CustomToastrAction();

    formData.append(`email[subject]`, args.values.email.subject);
    formData.append(`email[body]`, args.values.email.body);
    formData.append('email[cc]', cc_emails);
    formData.append('email[entity_type]', args.values.email.entity_type)
    // formData.append('email[to]', receiver_ids);
    formData.append('kanban[stage_id]', args.selectedCards?.stage_id)
    formData.append('kanban[job_application_ids]', args.selectedCards.job_application_ids)
    formData.append('kanban[rejected_ids]', args.selectedCards.rejected_ids)
    formData.append('kanban[status]', args.status)
    formData.append('kanban[moving_status]', args.moving_status)

    args.values.email.attachments =  Array.from(args.values.email.attachments)


    
    args.values.email.attachments.map((file, index) => 
    {
        formData.append(`email[attachments][]`, file);
    })
    
    var result;
    if(args.isActiveEmail){
        if(args.from == 'kanban')
        {
            formData.append('query', args.filterData.query) 
            formData.append('years_of_experience', args.filterData.years_of_experience) 
            formData.append('interview_score', args.filterData.interview_score) 
            formData.append('tech_score', args.filterData.tech_score)
            formData.append('desired_salary', args.filterData.desired_salary)
            formData.append('application_status', args.filterData.application_status)
            formData.append('source', args.filterData.source)
            formData.append('status', args.activeTab)
        }
        formData.append('from', args.from)
        result = await new Kanban().markActiveUnsuccessful(args.job_id, formData);
    }
    else
    {
        result = await new CandidateEmail().SendKanbanEmail(formData, args.router);
    }
        
    if(result?.response?.status == 200 || result.status == 200)
    {
        args.setShowLoader(false);
        args.setEmailModal(false);
        if(args.from == 'kanban') clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar)
        if(args.isActiveEmail && args.from == 'kanban'){
            args.setJobData(result.data.kanban_data)
        }
        else if(args.from == 'application_view') {
            args.setInitialData(result.data.application_data)
        }
        if(result.data.warning && result.data.warning.length > 0) 
        {
            customToastrAction.setNormalToastr(result.data.warning, 'error'); 
            // toastr.error(result.data.warning)
        }
          else
        { args.isActiveEmail ? customToastrAction.setNormalToastr(result.data.success, 'success') :  customToastrAction.setNormalToastr(TRANSLATION('toastr:email_sent'), 'success')}
        
    }
    else
    {
        args.setShowLoader(false);
        customToastrAction.setNormalToastr(result.response.data.error, 'warning'); 
        // toastr.warning(result.response.data.error);
    }

  
}



export function getEmails(values)
{
    var emails = []; 
    for(var element of values)
    {
    emails.push(element.email)
    }

    return emails;
}

export function removeAttachment(event, attachmentList, setAttachmentList, setFlagForRerender)
{   
    let remove_file_index = event.currentTarget.closest('.AttachmentChip').getAttribute('data-index')
    attachmentList.splice(remove_file_index, 1);
    setAttachmentList(attachmentList);
    setFlagForRerender(Math.random() * 10000);
}

export function getCandidateName(selectedCards)
{
    let name = null; 

    name = document.querySelector("[data-stage_id='"+selectedCards.stage_id+"']")?.closest('.react-trello-lane')?.querySelectorAll('[data-application_id]')
    if(name && name.length > 0)
        { for(let i=0; i< name.length; i++)
            {
                if(name[i].checked)
                { 
                    name = name[i].closest('div').querySelector('h2').textContent;
                    break;
                }
            }
        }   
   return name;
}

export function getEmailTo(props)
{
    let send_email = props?.system_notification_email;
    let email_To = props.emailTo
  
        for(let element of props.emailTo)
        {
            if( element.email != props?.system_notification_email && element.email == props.session.email)
            {
            email_To = props.emailFrom
            break;
            }
        }
    

    if(Array.isArray(email_To))
    {
    for(let element of email_To)
    {
        if( (element.name || element.email) && (element.name || element.email) != props?.system_notification_email)
        {
            send_email = send_email+', '+element.name || element.email
        }
    }
    }
    else
    {
        if( email_To.name || email_To.email )
        {
            send_email = send_email+', '+email_To.name || email_To.email
        }
    }
    
        if(['send_email_candidate_button', 'not_send_email_candidate_button'].includes(props.openFrom)){
        // if(props.data.application.email || props.data.application.name)
        // {
        //     send_email = send_email+', '+ props.data.application.name || props.data.application.email
        // }
        // else
        // {
        //     send_email = send_email+', '+ props.data.application.agency_detail.name || props.data.application.agency_detail.email
        // }


         if( props.data.application && (props.data.application.email))
        {
            send_email = send_email+', '+ props.data.application.name || props.data.application.email
        }

        // if( props.data.application.agency_detail)
        // {
        //     send_email = send_email+', '+ props.data.application.agency_detail
        // }
    }
    return send_email;
    // `${props?.data?.application.name||props?.data?.application.email}${!props?.data?.application?.name.includes(props?.system_notification_email) ? `, ${props?.system_notification_email}` : ''}`
}

export function getPurposeOptions(data){
  let options = []
  if(data)
  {
    for( let element of data)
    {
      options.push({
                    value: element.id, 
                    label: element.purpose,
                    type: element.type,
                    template_type: element.template_type,
                    template_id: element.template_id,
                    is_custom_master: element.is_custom_master || false
                  })
    }
    return options;
  }
}

export async function getCustomTemplate(select_option, formik, setSubject, setDataVariables, setRefreshKey, t){
  var reviewEmailService     =   new ReviewEmailServices();
  const reviewEmailActions   =   new ReviewEmailActions();
  var master_template_id  =    select_option.value
  var master_template_type  =    select_option.type
  var template_type  =    select_option.template_type
  var template_id  =    select_option.template_id
  var body         =    {type: template_type, master: false, is_custom_master: select_option.is_custom_master || false };
  var result       =    await reviewEmailService.getSystemEmailTemplate(body, template_id);
  
  if(result.request.status == 200)
  { 
    await formik.setFieldValue('email.subject', result.data.subject);
    await formik.setFieldValue('email.body', result.data.email_body);
    await formik.setFieldValue('email.entity_type',result.data.entity_type);
    await setSubject(reviewEmailActions.subjectVars(t));
    await setDataVariables(reviewEmailActions.bodyVars(t));
    await setRefreshKey(Math.random() * 10000);
  }
}

export function onKeyDown(keyEvent) 
{
  if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
    keyEvent.preventDefault();
  }
}

export function agencyEmailTo(props, selectedToValues, setSelectedToValues){
  if(selectedToValues.length == 0)
  {
    let send_email = [{name: props?.system_notification_email, email: props?.system_notification_email}];
    props.data.application.email ? send_email.push({name: props.data.application.name, email: props.data.application.email}) : ''
    props.data.application.agency_user_email ? send_email.push({name: props.data.application.agency_detail, email: props.data.application.agency_user_email}) : ''
    setSelectedToValues(send_email)
  }
}